<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Panel header="Gerenciamento de Responsaveis" style="height: 100%">
        <Toolbar class="p-mb-4">
          <template #start>
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="mr-2"
              @click="showCreate()"
            />
          </template>
          <template #end> </template>
        </Toolbar>
        <DataTable
          ref="dt"
          dataKey="id"
          class="p-datatable-sm"
          :value="list"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:filters="filters"
          :lazy="true"
          :totalRecords="totalRecords"
          :loading="loading"
          @page="onPage($event)"
          @filter="onFilter($event)"
          filterDisplay="row"
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} responsáveis."
        >
          <template #empty>
            <div class="p-text-center">Nenhum resultado encontrado...</div>
          </template>
          <Column
            header="Nome"
            field="name"
            ref="name"
            filterMatchMode="startsWith"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Pesquisar por nome"
              />
            </template>
            <template #body="slotProps">
              {{ slotProps.data.name }}
            </template>
          </Column>
          <Column
            header="E-mail"
            field="email"
            ref="email"
            filterMatchMode="startsWith"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Pesquisar por email"
              />
            </template>
            <template #body="slotProps">
              {{ slotProps.data.email }}
            </template>
          </Column>
          <Column
            header="Matricula"
            field="credential"
            ref="credential"
            filterMatchMode="startsWith"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Pesquisar por matrícula"
              />
            </template>
            <template #body="slotProps">
              {{ slotProps.data.credential }}
            </template>
          </Column>
          <Column header="Contato" field="contact" ref="contact">
            <template #body="slotProps">
              {{ slotProps.data.contact }}
            </template>
          </Column>
          <Column header="Status" field="status">
            <template #body="slotProps">
              <span
                :class="'badge status-' + slotProps.data.status"
                @click="changeStatus(slotProps.data)"
                v-tooltip.top="'Clique para alterar Status'"
                style="cursor: pointer"
                >{{ $Util.formatAtivo(slotProps.data.status) }}</span
              >
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="showUpdate(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA EDITAR'"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="showRemove(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA EXCLUIR'"
              />
            </template>
          </Column>
        </DataTable>
      </Panel>
    </div>
    <ConfirmDialog></ConfirmDialog>
  </div>

  <!--MODAL CADASTRAR-->
  <dialog-form :objSelected="obj" @findAll="findAll" />
  <!--FIM MODAL CADASTRAR-->
</template>

<script>
import { FilterMatchMode } from "primevue/api";

//models
import Responsible from "../../../src/models/internal/responsible";

//Services
import ResponsibleService from "../../../src/service/internal/responsible/responsible_service";

//components
import DialogForm from "./components/dialog-form.vue";

export default {
  components: {
    DialogForm,
  },
  data() {
    return {
      loading: false,
      list: [],
      obj: new Responsible({}),
      permissoes: [],
      totalRecords: 0,
      filtersPermissions: {},
      lazyParams: {},
      service: new ResponsibleService(),
      filters: {
        name: { value: "", matchMode: "contains" },
        credential: { value: "", matchMode: "contains" },
        email: { value: "", matchMode: "contains" },
      },
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      size: this.$refs.dt.rows,
      name: "",
      credential: "",
      email: "",
      sortField: null,
      sortOrder: null,
    };
    this.findAll();
  },
  methods: {
    showCreate() {
      this.obj = new Responsible({});
      this.$store.state.views.responsible.dialogForm = true;
    },
    showUpdate(obj) {
      this.obj = obj;
      this.$store.state.views.responsible.dialogForm = true;
    },
    showRemove(obj) {
      this.$confirm.require({
        message: "Deseja Excluir esse registro?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.service
            .delete(obj.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((error) => {
              this.$msgErro(error);
            });
        },
      });
    },
    findAll() {
      this.loading = true;

      /** AJUSTANTO FILTERS **/
      this.lazyParams.name =
        this.lazyParams.name == null ? "" : this.lazyParams.name;
      this.lazyParams.credential =
        this.lazyParams.credential == null ? "" : this.lazyParams.credential;
      this.lazyParams.email =
        this.lazyParams.email == null ? "" : this.lazyParams.email;

      this.service.findAllResponsible(this.lazyParams).then((data) => {
        this.list = data.content;
        this.totalRecords = data.totalElements;
        this.loading = false;
      });
    },
    onPage(event) {
      this.lazyParams.page = event.page;
      this.lazyParams.size = event.rows;
      this.findAll();
    },
    onFilter() {
      this.lazyParams.page = 0;
      this.lazyParams.name = this.filters.name.value;
      this.lazyParams.credential = this.filters.credential.value;
      this.lazyParams.email = this.filters.email.value;
      this.findAll();
    },
    initFilters() {
      this.filtersPermissions = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    changeStatus(data) {
      this.service
        .changeStatus(data.id)
        .then((data) => {
          if (data.status === 200) {
            this.$msgSuccess(data);
            this.findAll();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
